import CompanyField from './component';
import { CompanyFieldProps } from './types';

export default CompanyField;
export type { CompanyFieldProps };
